<template>
  <li>
    <component
      :is="linkComponent"
      :to="to"
      :href="href"
      :target="target"
      :rel="rel"
      class="footer-link"
      @click="handleClick"
    >
      <i v-if="icon" :class="icon"></i>
      <slot></slot>
    </component>
  </li>
</template>

<script>
export default {
  name: 'FooterLink',
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    href: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: null
    },
    rel: {
      type: String,
      default: null
    }
  },
  computed: {
    linkComponent() {
      return this.to ? 'router-link' : 'a'
    }
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      // In Vue 3, emetti sempre l'evento se necessario
      // Il parent può decidere se gestirlo o meno
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>
.footer-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.95rem;
  padding: 0.5rem 0;
  position: relative;
  border-radius: 4px;
  cursor: pointer;
}

.footer-link::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 0;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 2px;
  transition: height 0.3s ease;
}

.footer-link:hover {
  color: #ffffff;
  transform: translateX(8px);
  text-decoration: none;
  padding-left: 0.5rem;
}

.footer-link:hover::before {
  height: 60%;
}

.footer-link i {
  width: 20px;
  text-align: center;
  font-size: 1rem;
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.3));
}

.footer-link:hover i {
  transform: scale(1.2);
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.6));
}
</style>

